import React, { useState } from 'react';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import StaticPopupNew from 'components/StaticPopupNew';

const formatRequestedAt = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true,
    });
};

const QuotationUpdateRequestHistory = ({ supplier }) => {
    const [isOpen, setIsOpen] = useState(false);
    const request = supplier?.quotationUpdateRequest;
    const requestCount = Number(request?.requestCount || 0);
    if (!Number.isFinite(requestCount) || requestCount < 1) return null;

    const history = request.history?.length
        ? [...request.history].sort((first, second) => second.requestNumber - first.requestNumber)
        : [{ requestNumber: requestCount, requestedBy: request.requestedBy, requestedAt: request.requestedAt }];
    const unavailableCount = Math.max(requestCount - history.length, 0);

    return (
        <>
            <button
                type="button"
                title="Quotation update request history"
                aria-label={`View ${requestCount} quotation update ${requestCount === 1 ? 'request' : 'requests'} for ${supplier.businessName}`}
                aria-haspopup="dialog"
                aria-expanded={isOpen}
                onClick={(event) => { event.stopPropagation(); setIsOpen(true); }}
                className="relative my-2 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-[#F5D7C3] bg-[#FFF7F0] text-[#D95700] transition-colors hover:bg-[#FFEADB] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FD6600] focus-visible:ring-offset-2"
            >
                <NotificationsNoneOutlinedIcon style={{ fontSize: 19 }} aria-hidden="true" />
                <span className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#FD6600] px-1 text-[9px] font-bold leading-none text-white ring-2 ring-white">
                    {requestCount}
                </span>
            </button>

            {isOpen && (
                <StaticPopupNew
                    openModal={isOpen}
                    handleClose={() => setIsOpen(false)}
                    header="Quotation Update Request History"
                    width="2xl"
                    bodyStyle="p-4"
                >
                    <div className="space-y-4 text-left text-sm font-normal text-[#3F4B64]">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                            <p className="font-semibold text-[#2D2D11]">{supplier.businessName}</p>
                            <span className="rounded-full bg-[#FFF0E5] px-3 py-1 text-xs font-semibold text-[#C24E00]">
                                {requestCount} {requestCount === 1 ? 'request' : 'requests'}
                            </span>
                        </div>
                        <div className="overflow-x-auto rounded-xl border border-[#E7E7DD]">
                            <table className="w-full text-left text-xs">
                                <thead className="bg-[#F8F8F3] text-[#6F6F68]">
                                    <tr>
                                        <th className="px-4 py-3 font-semibold">Request</th>
                                        <th className="px-4 py-3 font-semibold">Requested By</th>
                                        <th className="px-4 py-3 font-semibold">Requested On (IST)</th>
                                        <th className="px-4 py-3 font-semibold">Message to Vendor</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-[#E7E7DD]">
                                    {history.map((entry) => (
                                        <tr key={entry.requestNumber}>
                                            <td className="px-4 py-3">#{entry.requestNumber}</td>
                                            <td className="px-4 py-3 font-medium">{entry.requestedBy?.name || '-'}</td>
                                            <td className="whitespace-nowrap px-4 py-3">{formatRequestedAt(entry.requestedAt)}</td>
                                            <td className="min-w-[180px] max-w-sm whitespace-pre-wrap break-words px-4 py-3 leading-5">{entry.managerMessage || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {unavailableCount > 0 && (
                            <p className="text-xs leading-5 text-[#6F6F68]">
                                Details for {unavailableCount} earlier {unavailableCount === 1 ? 'request were' : 'requests were'} not recorded. The available request history is shown above.
                            </p>
                        )}
                    </div>
                </StaticPopupNew>
            )}
        </>
    );
};

export default QuotationUpdateRequestHistory;
